__turbopack_context__.v({
  "App": "d7FVGa_App",
  "buttonApp": "d7FVGa_buttonApp",
  "dFlex": "d7FVGa_dFlex",
});
